import {
  StudyYearCategoryCompanyWithChildrenSchema,
  GetStudyYearCategoryCompanyRequest,
  UpdateStudyYearCategoryCompanyRequest,
  GetStudyYearCategoryCompanyParentRequest,
  GetStudyYearCategoryCompanyHistoryRequest,
} from '@/types/study-year-category-company';

import { api } from './index';

class StudyYearCategoryCompaniesService {
  /**
   * Get study year category company by ID (V3)
   * GET /v3/sy-category-companies/{study_year_category_company_id}
   * NEW IN V3 ✅
   */
  async getStudyYearCategoryCompany(
    request: GetStudyYearCategoryCompanyRequest
  ): Promise<StudyYearCategoryCompanyWithChildrenSchema> {
    try {
      const response = await api.get(
        `/sy-category-companies/${request.studyYearCategoryCompanyId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        `Error fetching study year category company ${request.studyYearCategoryCompanyId} (V3):`,
        error
      );
      throw error;
    }
  }

  /**
   * Update study year category company (V3)
   * PATCH /v3/sy-category-companies/{study_year_category_company_id}
   * NEW IN V3 ✅
   */
  async updateStudyYearCategoryCompany(
    request: UpdateStudyYearCategoryCompanyRequest
  ): Promise<StudyYearCategoryCompanyWithChildrenSchema> {
    try {
      const { studyYearCategoryCompanyId, ...updateData } = request;
      const response = await api.patch(
        `/sy-category-companies/${studyYearCategoryCompanyId}`,
        updateData
      );
      return response.data;
    } catch (error) {
      console.error(
        `Error updating study year category company ${request.studyYearCategoryCompanyId} (V3):`,
        error
      );
      throw error;
    }
  }

  /**
   * Get study year category company parent (V3)
   * GET /v3/sy-category-companies/{study_year_category_company_id}/parent
   * NEW IN V3 ✅
   */
  async getStudyYearCategoryCompanyParent(
    request: GetStudyYearCategoryCompanyParentRequest
  ): Promise<StudyYearCategoryCompanyWithChildrenSchema> {
    try {
      const response = await api.get(
        `/sy-category-companies/${request.studyYearCategoryCompanyId}/parent`
      );
      return response.data;
    } catch (error) {
      console.error(
        `Error fetching study year category company parent ${request.studyYearCategoryCompanyId} (V3):`,
        error
      );
      throw error;
    }
  }

  /**
   * Get study year category company history (V3)
   * GET /v3/sy-category-companies/{study_year_category_company_id}/history
   * NEW IN V3 ✅
   */
  async getStudyYearCategoryCompanyHistory(
    request: GetStudyYearCategoryCompanyHistoryRequest
  ): Promise<StudyYearCategoryCompanyWithChildrenSchema> {
    try {
      const response = await api.get(
        `/sy-category-companies/${request.studyYearCategoryCompanyId}/history`
      );
      return response.data;
    } catch (error) {
      console.error(
        `Error fetching study year category company history ${request.studyYearCategoryCompanyId} (V3):`,
        error
      );
      throw error;
    }
  }
}

export const studyYearCategoryCompaniesService = new StudyYearCategoryCompaniesService();
